<app-manage-project [hideTitleBar]="true"></app-manage-project>
